import React from "react";
import UploadSingleImageButton from "../../Components/Buttons/UploadSingleImageButton";

const WatermarkSingleImageUpload: React.FC = () => {
  return (
    <>
      <UploadSingleImageButton />
    </>
  );
};

export default WatermarkSingleImageUpload;
